import '@/styles/mobile-normalize.css'
import '@/styles/animate.css'
import '@/styles/transitions.css'
import 'vue-toast-notification/dist/index.css'
import 'vue-slider-component/theme/default.css'

import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '@/App'
import router from '@/router'
import store from '@/stores'
import { InlineSvgPlugin, InlineSvgComponent } from '@/components/InlineSvg'
import theme from '@/theme.js'
import VueToast from 'vue-toast-notification'
import VueTyper from 'vue-typer'
import VueSlider from 'vue-slider-component'
import VueAnalytics from 'vue-analytics'
import Config from '~/config/index'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(InlineSvgPlugin)
Vue.use(VueToast)
Vue.use(VueTyper)
Vue.component('VueSlider', VueSlider)

theme.applyTheme()

// These svg are used with <inline-svg> which takes some time to render svgs for the first time.
// Without preloading images, it gives a cringy feeling when svg are rendered,
// especially on mobiles where it's clearly visible that the elements are resized as the image contained into is loaded.
const svgsToPreload =
[
    // require('@/assets/img/circle-spinner.svg'),
]

function buildApp ()
{
    console.log('Starting analytics with id', Config.analyticsId)
    const analyticsConfig =
    {
        id: Config.analyticsId,
        fields: { cookieDomain: 'none' },
        router,
        autoTracking: { screenView: true }
    }
    Vue.use(VueAnalytics, analyticsConfig)

    window.app = new Vue({
        el: '#app',
        router,
        store,
        template: '<App />',
        components: { App },
    
        data ()
        {
            return {
            }
        },
    
        methods:
        {
        },
    
        created: onAppCreated,
        mounted: onAppMounted
    })
}

function onAppCreated ()
{
    for (const path of svgsToPreload) InlineSvgComponent.methods.cacheImage(path)
}

function onAppMounted ()
{
}

buildApp()



// WEBPACK FOOTER //
// ./src/main.js